import { Reveal, SectionHeading } from "./Reveal";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQS } from "../../data/content";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: f.answer,
    },
  })),
};

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative border-t border-[#c9a24d]/25 bg-[#0a0a0a] py-24 lg:py-32"
    >
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />

      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            center
            overline="FAQ"
            title="Toronto construction questions, answered."
            sub="Everything homeowners and developers across Toronto and the GTA ask us before starting a project."
          />
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-12 w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.question}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-white/10"
              >
                <AccordionTrigger className="py-5 text-left font-hero text-base font-semibold text-white hover:no-underline sm:text-lg">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-neutral-400 sm:text-[15px]">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
